import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { RolesState } from '../reducers/roles.reducer';
import * as selectors from '../selectors/roles.selectors';

@Injectable({
  providedIn: 'root',
})
export class RolesFacadeService extends FacadeService {
  constructor(public override store: Store<RolesState>) {
    super(store);
  }

  // OBSERVABLES
  roles$ = this.storeSelect(selectors.getRolesState);

  hasRole$ = (role: string) => this.roles$.pipe(map((state) => !!state?.roles?.[role]));

  // OBSERVABLE'S VALUES
  get roles() {
    return this.storeSnapshot(this.roles$);
  }
}
